import React from "react";
import $ from "classnames";
import url from "url";
import styles from "./Wayfinding.module.css";
import merge from "lodash/merge";

const Wayfinding = ({ appId, DURL, disableLoginLink, endpoints }) => {
  const URLs = merge(
    {
      login: "account.collegeboard.org/login/login",
    },
    endpoints
  );

  let params = {};
  const { studentHelp, professionalHelp } = endpoints;

  if (appId) {
    params["appId"] = appId;
  }
  if (DURL) {
    params["DURL"] = DURL;
  }

  const loginURL = url.format({
    protocol: "https",
    host: URLs.login,
    query: params,
  });

  return (
    <div className={`${styles.root} iam-wayfinding`}>
      <div className="container">
        <div className="row">
          <div className="col-xs-12 display-flex justify-content-between flex-xs-column-only">
            {!disableLoginLink && (
              <a href={loginURL} className="cb-text-icon-left cb-palette-blue5">
                <span className="cb-glyph cb-left" aria-hidden="true"></span>
                <span>Go to Sign In</span>
              </a>
            )}
            <p>
              Get Help{" "}
              <a
                className="cb-link-black"
                href={studentHelp || defaultEndpoints["url_student_help"]}
                target="_blank"
              >
                Student
              </a>{" "}
              or{" "}
              <a
                className="cb-link-black"
                href={
                  professionalHelp || defaultEndpoints["url_professional_help"]
                }
                target="_blank"
              >
                Professional
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Wayfinding;
